import React, { FC } from 'react'
import { Text, Box, Accordion, AccordionItem, AccordionButton, AccordionPanel } from '@chakra-ui/react'
import { MinusIcon, AddIcon } from '@chakra-ui/icons'
import { useTranslation } from 'react-i18next'
import { ScenarioType, Steps } from '../../state/interfaces'
import { selectCurrentStep, selectScenario } from '../../state'
import { useSelector } from 'react-redux'

export const Accordions: FC = () => {
  const { t } = useTranslation()
  const scenario = useSelector(selectScenario)
  const currentStep = useSelector(selectCurrentStep)

  return (
    <Accordion allowToggle defaultIndex={[0]} marginTop="2vh">
      <AccordionItem textAlign="center" width="100%" border="0" fontSize="xxs">
        {({ isExpanded }) => (
          <>
            <AccordionButton color="error" justifyContent="center" _focus={{ boxShadow: 'none' }}>
              <Box marginRight={2} textTransform="uppercase" fontSize="xxs">
                {t('common_details')}
              </Box>
              {isExpanded ? <MinusIcon fontSize="xxs" /> : <AddIcon fontSize="xxs" />}
            </AccordionButton>
            <AccordionPanel>
              {scenario &&
                (scenario.type === ScenarioType.MOBILE_REVIEWS || scenario.type === ScenarioType.INTERNET_REVIEWS) && (
                  <Text>{t('common_important-review')}</Text>
                )}
              {scenario && scenario.type === ScenarioType.CHECK_AVAILABILITY && (
                <Text>{t('common_important-check-availability')}</Text>
              )}
              {scenario && scenario.type === ScenarioType.INTERNET_ALERT && <Text>{t('common_important-alert')}</Text>}
              {/*todo: use dynamic Accordion Value*/}
              {scenario &&
                scenario.type === ScenarioType.INTERNET &&
                currentStep &&
                currentStep.id === Steps.VALUE_CUSTOMER_OPINIONS && (
                  <Text>{t('value-customer-opinions_important')}</Text>
                )}
              {scenario &&
                scenario.type === ScenarioType.INTERNET &&
                currentStep &&
                currentStep.id === Steps.VALUE_COST_EFFICIENCY && <Text>{t('value-cost-efficiency_important')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.INTERNET &&
                currentStep &&
                currentStep.id === Steps.VALUE_PRICE && <Text>{t('value-price_important')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.MOBILE &&
                currentStep &&
                currentStep.id === Steps.BIG_ENTREPRISE && <Text>{t('big-entreprise_details')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.INTERNET &&
                currentStep &&
                (currentStep.id === Steps.VALUE_THE_MOST_CHOICES_1 ||
                  currentStep.id === Steps.VALUE_THE_MOST_CHOICES_2) && (
                  <Text>{t('value-the-most-choice-details')}</Text>
                )}
              {scenario &&
                scenario.type === ScenarioType.FIBER_OPTIC_ALERT &&
                currentStep &&
                currentStep.id === Steps.CONFIRM_FIBER_OPTIC_ALERT && <Text>{t('fiber-optic_details')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.FIBER_OPTIC_ALERT &&
                currentStep &&
                currentStep.id === Steps.EMAIL_ADDRESS && <Text>{t('fiber-optic-slides-details')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.FIBER_OPTIC_ALERT &&
                currentStep &&
                currentStep.id === Steps.ADDRESS_LOCATION && <Text>{t('fiber-optic-slides-details')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.FIBER_OPTIC_ALERT &&
                currentStep &&
                currentStep.id === Steps.CONFIRM_ALERT && <Text>{t('fiber-optic-slide-details')}</Text>}
              {scenario &&
                scenario.type === ScenarioType.MOBILE &&
                currentStep &&
                currentStep.id === Steps.CALLING_OPTIONS && <Text>{t('calling-options-details')}</Text>}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  )
}
